/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CascadeDropdownRequestDTO,
  LocationDTO,
  LocationHierarchyDTO,
  LocationValidationRequestDTO,
  SearchLocationsParams,
  SimulateLocation200,
  SimulateLocationParams,
  ValidateLocationSelectionParams,
  ValidationResultDTO
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Validate location selection against configuration
 */
export const validateLocationSelection = (
    locationValidationRequestDTO: LocationValidationRequestDTO,
    params: ValidateLocationSelectionParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ValidationResultDTO>(
      {url: `/api/v1/locations/validate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: locationValidationRequestDTO,
        params, signal
    },
      options);
    }
  


export const getValidateLocationSelectionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validateLocationSelection>>, TError,{data: LocationValidationRequestDTO;params: ValidateLocationSelectionParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof validateLocationSelection>>, TError,{data: LocationValidationRequestDTO;params: ValidateLocationSelectionParams}, TContext> => {

const mutationKey = ['validateLocationSelection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof validateLocationSelection>>, {data: LocationValidationRequestDTO;params: ValidateLocationSelectionParams}> = (props) => {
          const {data,params} = props ?? {};

          return  validateLocationSelection(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ValidateLocationSelectionMutationResult = NonNullable<Awaited<ReturnType<typeof validateLocationSelection>>>
    export type ValidateLocationSelectionMutationBody = LocationValidationRequestDTO
    export type ValidateLocationSelectionMutationError = unknown

    /**
 * @summary Validate location selection against configuration
 */
export const useValidateLocationSelection = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validateLocationSelection>>, TError,{data: LocationValidationRequestDTO;params: ValidateLocationSelectionParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof validateLocationSelection>>,
        TError,
        {data: LocationValidationRequestDTO;params: ValidateLocationSelectionParams},
        TContext
      > => {

      const mutationOptions = getValidateLocationSelectionMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary Generate sample location data based on configuration
 */
export const simulateLocation = (
    params: SimulateLocationParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SimulateLocation200>(
      {url: `/api/v1/locations/simulate`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getSimulateLocationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof simulateLocation>>, TError,{params: SimulateLocationParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof simulateLocation>>, TError,{params: SimulateLocationParams}, TContext> => {

const mutationKey = ['simulateLocation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof simulateLocation>>, {params: SimulateLocationParams}> = (props) => {
          const {params} = props ?? {};

          return  simulateLocation(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SimulateLocationMutationResult = NonNullable<Awaited<ReturnType<typeof simulateLocation>>>
    
    export type SimulateLocationMutationError = unknown

    /**
 * @summary Generate sample location data based on configuration
 */
export const useSimulateLocation = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof simulateLocation>>, TError,{params: SimulateLocationParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof simulateLocation>>,
        TError,
        {params: SimulateLocationParams},
        TContext
      > => {

      const mutationOptions = getSimulateLocationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary Get locations for cascading dropdown
 */
export const getCascadeLocations = (
    cascadeDropdownRequestDTO: CascadeDropdownRequestDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LocationDTO[]>(
      {url: `/api/v1/locations/cascade`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cascadeDropdownRequestDTO, signal
    },
      options);
    }
  


export const getGetCascadeLocationsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getCascadeLocations>>, TError,{data: CascadeDropdownRequestDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof getCascadeLocations>>, TError,{data: CascadeDropdownRequestDTO}, TContext> => {

const mutationKey = ['getCascadeLocations'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getCascadeLocations>>, {data: CascadeDropdownRequestDTO}> = (props) => {
          const {data} = props ?? {};

          return  getCascadeLocations(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetCascadeLocationsMutationResult = NonNullable<Awaited<ReturnType<typeof getCascadeLocations>>>
    export type GetCascadeLocationsMutationBody = CascadeDropdownRequestDTO
    export type GetCascadeLocationsMutationError = unknown

    /**
 * @summary Get locations for cascading dropdown
 */
export const useGetCascadeLocations = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getCascadeLocations>>, TError,{data: CascadeDropdownRequestDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getCascadeLocations>>,
        TError,
        {data: CascadeDropdownRequestDTO},
        TContext
      > => {

      const mutationOptions = getGetCascadeLocationsMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary Get all zones
 */
export const getLocationZones = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LocationDTO[]>(
      {url: `/api/v1/locations/zones`, method: 'GET', signal
    },
      options);
    }
  

export const getGetLocationZonesQueryKey = () => {
    return [`/api/v1/locations/zones`] as const;
    }

    
export const getGetLocationZonesQueryOptions = <TData = Awaited<ReturnType<typeof getLocationZones>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationZones>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLocationZonesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocationZones>>> = ({ signal }) => getLocationZones(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLocationZones>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLocationZonesQueryResult = NonNullable<Awaited<ReturnType<typeof getLocationZones>>>
export type GetLocationZonesQueryError = unknown


export function useGetLocationZones<TData = Awaited<ReturnType<typeof getLocationZones>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationZones>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocationZones>>,
          TError,
          Awaited<ReturnType<typeof getLocationZones>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLocationZones<TData = Awaited<ReturnType<typeof getLocationZones>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationZones>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocationZones>>,
          TError,
          Awaited<ReturnType<typeof getLocationZones>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLocationZones<TData = Awaited<ReturnType<typeof getLocationZones>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationZones>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get all zones
 */

export function useGetLocationZones<TData = Awaited<ReturnType<typeof getLocationZones>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationZones>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLocationZonesQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get regions by zone
 */
export const getRegionsByZone = (
    zoneId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LocationDTO[]>(
      {url: `/api/v1/locations/zones/${zoneId}/regions`, method: 'GET', signal
    },
      options);
    }
  

export const getGetRegionsByZoneQueryKey = (zoneId?: number,) => {
    return [`/api/v1/locations/zones/${zoneId}/regions`] as const;
    }

    
export const getGetRegionsByZoneQueryOptions = <TData = Awaited<ReturnType<typeof getRegionsByZone>>, TError = unknown>(zoneId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegionsByZone>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRegionsByZoneQueryKey(zoneId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRegionsByZone>>> = ({ signal }) => getRegionsByZone(zoneId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(zoneId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRegionsByZone>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetRegionsByZoneQueryResult = NonNullable<Awaited<ReturnType<typeof getRegionsByZone>>>
export type GetRegionsByZoneQueryError = unknown


export function useGetRegionsByZone<TData = Awaited<ReturnType<typeof getRegionsByZone>>, TError = unknown>(
 zoneId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegionsByZone>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRegionsByZone>>,
          TError,
          Awaited<ReturnType<typeof getRegionsByZone>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRegionsByZone<TData = Awaited<ReturnType<typeof getRegionsByZone>>, TError = unknown>(
 zoneId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegionsByZone>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRegionsByZone>>,
          TError,
          Awaited<ReturnType<typeof getRegionsByZone>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRegionsByZone<TData = Awaited<ReturnType<typeof getRegionsByZone>>, TError = unknown>(
 zoneId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegionsByZone>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get regions by zone
 */

export function useGetRegionsByZone<TData = Awaited<ReturnType<typeof getRegionsByZone>>, TError = unknown>(
 zoneId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegionsByZone>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetRegionsByZoneQueryOptions(zoneId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get streets by ward
 */
export const getStreetsByWard = (
    wardId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LocationDTO[]>(
      {url: `/api/v1/locations/wards/${wardId}/streets`, method: 'GET', signal
    },
      options);
    }
  

export const getGetStreetsByWardQueryKey = (wardId?: number,) => {
    return [`/api/v1/locations/wards/${wardId}/streets`] as const;
    }

    
export const getGetStreetsByWardQueryOptions = <TData = Awaited<ReturnType<typeof getStreetsByWard>>, TError = unknown>(wardId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreetsByWard>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStreetsByWardQueryKey(wardId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStreetsByWard>>> = ({ signal }) => getStreetsByWard(wardId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(wardId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStreetsByWard>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetStreetsByWardQueryResult = NonNullable<Awaited<ReturnType<typeof getStreetsByWard>>>
export type GetStreetsByWardQueryError = unknown


export function useGetStreetsByWard<TData = Awaited<ReturnType<typeof getStreetsByWard>>, TError = unknown>(
 wardId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreetsByWard>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStreetsByWard>>,
          TError,
          Awaited<ReturnType<typeof getStreetsByWard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetStreetsByWard<TData = Awaited<ReturnType<typeof getStreetsByWard>>, TError = unknown>(
 wardId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreetsByWard>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStreetsByWard>>,
          TError,
          Awaited<ReturnType<typeof getStreetsByWard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetStreetsByWard<TData = Awaited<ReturnType<typeof getStreetsByWard>>, TError = unknown>(
 wardId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreetsByWard>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get streets by ward
 */

export function useGetStreetsByWard<TData = Awaited<ReturnType<typeof getStreetsByWard>>, TError = unknown>(
 wardId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreetsByWard>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetStreetsByWardQueryOptions(wardId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Search locations by name and directory
 */
export const searchLocations = (
    params: SearchLocationsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LocationDTO[]>(
      {url: `/api/v1/locations/search`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getSearchLocationsQueryKey = (params?: SearchLocationsParams,) => {
    return [`/api/v1/locations/search`, ...(params ? [params]: [])] as const;
    }

    
export const getSearchLocationsQueryOptions = <TData = Awaited<ReturnType<typeof searchLocations>>, TError = unknown>(params: SearchLocationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchLocations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchLocationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchLocations>>> = ({ signal }) => searchLocations(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchLocations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type SearchLocationsQueryResult = NonNullable<Awaited<ReturnType<typeof searchLocations>>>
export type SearchLocationsQueryError = unknown


export function useSearchLocations<TData = Awaited<ReturnType<typeof searchLocations>>, TError = unknown>(
 params: SearchLocationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchLocations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchLocations>>,
          TError,
          Awaited<ReturnType<typeof searchLocations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchLocations<TData = Awaited<ReturnType<typeof searchLocations>>, TError = unknown>(
 params: SearchLocationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchLocations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchLocations>>,
          TError,
          Awaited<ReturnType<typeof searchLocations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchLocations<TData = Awaited<ReturnType<typeof searchLocations>>, TError = unknown>(
 params: SearchLocationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchLocations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Search locations by name and directory
 */

export function useSearchLocations<TData = Awaited<ReturnType<typeof searchLocations>>, TError = unknown>(
 params: SearchLocationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchLocations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getSearchLocationsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get all regions
 */
export const getLocationRegions = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LocationDTO[]>(
      {url: `/api/v1/locations/regions`, method: 'GET', signal
    },
      options);
    }
  

export const getGetLocationRegionsQueryKey = () => {
    return [`/api/v1/locations/regions`] as const;
    }

    
export const getGetLocationRegionsQueryOptions = <TData = Awaited<ReturnType<typeof getLocationRegions>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationRegions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLocationRegionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocationRegions>>> = ({ signal }) => getLocationRegions(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLocationRegions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLocationRegionsQueryResult = NonNullable<Awaited<ReturnType<typeof getLocationRegions>>>
export type GetLocationRegionsQueryError = unknown


export function useGetLocationRegions<TData = Awaited<ReturnType<typeof getLocationRegions>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationRegions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocationRegions>>,
          TError,
          Awaited<ReturnType<typeof getLocationRegions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLocationRegions<TData = Awaited<ReturnType<typeof getLocationRegions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationRegions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocationRegions>>,
          TError,
          Awaited<ReturnType<typeof getLocationRegions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLocationRegions<TData = Awaited<ReturnType<typeof getLocationRegions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationRegions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get all regions
 */

export function useGetLocationRegions<TData = Awaited<ReturnType<typeof getLocationRegions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationRegions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLocationRegionsQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get districts by region
 */
export const getDistrictsByRegion = (
    regionId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LocationDTO[]>(
      {url: `/api/v1/locations/regions/${regionId}/districts`, method: 'GET', signal
    },
      options);
    }
  

export const getGetDistrictsByRegionQueryKey = (regionId?: number,) => {
    return [`/api/v1/locations/regions/${regionId}/districts`] as const;
    }

    
export const getGetDistrictsByRegionQueryOptions = <TData = Awaited<ReturnType<typeof getDistrictsByRegion>>, TError = unknown>(regionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDistrictsByRegion>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDistrictsByRegionQueryKey(regionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDistrictsByRegion>>> = ({ signal }) => getDistrictsByRegion(regionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(regionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDistrictsByRegion>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDistrictsByRegionQueryResult = NonNullable<Awaited<ReturnType<typeof getDistrictsByRegion>>>
export type GetDistrictsByRegionQueryError = unknown


export function useGetDistrictsByRegion<TData = Awaited<ReturnType<typeof getDistrictsByRegion>>, TError = unknown>(
 regionId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDistrictsByRegion>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDistrictsByRegion>>,
          TError,
          Awaited<ReturnType<typeof getDistrictsByRegion>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDistrictsByRegion<TData = Awaited<ReturnType<typeof getDistrictsByRegion>>, TError = unknown>(
 regionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDistrictsByRegion>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDistrictsByRegion>>,
          TError,
          Awaited<ReturnType<typeof getDistrictsByRegion>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDistrictsByRegion<TData = Awaited<ReturnType<typeof getDistrictsByRegion>>, TError = unknown>(
 regionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDistrictsByRegion>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get districts by region
 */

export function useGetDistrictsByRegion<TData = Awaited<ReturnType<typeof getDistrictsByRegion>>, TError = unknown>(
 regionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDistrictsByRegion>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDistrictsByRegionQueryOptions(regionId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get complete location hierarchy for a location
 */
export const getLocationHierarchy = (
    locationId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LocationHierarchyDTO>(
      {url: `/api/v1/locations/hierarchy/${locationId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetLocationHierarchyQueryKey = (locationId?: number,) => {
    return [`/api/v1/locations/hierarchy/${locationId}`] as const;
    }

    
export const getGetLocationHierarchyQueryOptions = <TData = Awaited<ReturnType<typeof getLocationHierarchy>>, TError = unknown>(locationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationHierarchy>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLocationHierarchyQueryKey(locationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocationHierarchy>>> = ({ signal }) => getLocationHierarchy(locationId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(locationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLocationHierarchy>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLocationHierarchyQueryResult = NonNullable<Awaited<ReturnType<typeof getLocationHierarchy>>>
export type GetLocationHierarchyQueryError = unknown


export function useGetLocationHierarchy<TData = Awaited<ReturnType<typeof getLocationHierarchy>>, TError = unknown>(
 locationId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationHierarchy>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocationHierarchy>>,
          TError,
          Awaited<ReturnType<typeof getLocationHierarchy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLocationHierarchy<TData = Awaited<ReturnType<typeof getLocationHierarchy>>, TError = unknown>(
 locationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationHierarchy>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocationHierarchy>>,
          TError,
          Awaited<ReturnType<typeof getLocationHierarchy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLocationHierarchy<TData = Awaited<ReturnType<typeof getLocationHierarchy>>, TError = unknown>(
 locationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationHierarchy>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get complete location hierarchy for a location
 */

export function useGetLocationHierarchy<TData = Awaited<ReturnType<typeof getLocationHierarchy>>, TError = unknown>(
 locationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationHierarchy>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLocationHierarchyQueryOptions(locationId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get wards by district
 */
export const getWardsByDistrict = (
    districtId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LocationDTO[]>(
      {url: `/api/v1/locations/districts/${districtId}/wards`, method: 'GET', signal
    },
      options);
    }
  

export const getGetWardsByDistrictQueryKey = (districtId?: number,) => {
    return [`/api/v1/locations/districts/${districtId}/wards`] as const;
    }

    
export const getGetWardsByDistrictQueryOptions = <TData = Awaited<ReturnType<typeof getWardsByDistrict>>, TError = unknown>(districtId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWardsByDistrict>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWardsByDistrictQueryKey(districtId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWardsByDistrict>>> = ({ signal }) => getWardsByDistrict(districtId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(districtId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWardsByDistrict>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetWardsByDistrictQueryResult = NonNullable<Awaited<ReturnType<typeof getWardsByDistrict>>>
export type GetWardsByDistrictQueryError = unknown


export function useGetWardsByDistrict<TData = Awaited<ReturnType<typeof getWardsByDistrict>>, TError = unknown>(
 districtId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWardsByDistrict>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWardsByDistrict>>,
          TError,
          Awaited<ReturnType<typeof getWardsByDistrict>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetWardsByDistrict<TData = Awaited<ReturnType<typeof getWardsByDistrict>>, TError = unknown>(
 districtId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWardsByDistrict>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWardsByDistrict>>,
          TError,
          Awaited<ReturnType<typeof getWardsByDistrict>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetWardsByDistrict<TData = Awaited<ReturnType<typeof getWardsByDistrict>>, TError = unknown>(
 districtId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWardsByDistrict>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get wards by district
 */

export function useGetWardsByDistrict<TData = Awaited<ReturnType<typeof getWardsByDistrict>>, TError = unknown>(
 districtId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWardsByDistrict>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetWardsByDistrictQueryOptions(districtId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get locations by directory ID
 */
export const getLocationsByDirectory = (
    directoryId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LocationDTO[]>(
      {url: `/api/v1/locations/directory/${directoryId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetLocationsByDirectoryQueryKey = (directoryId?: number,) => {
    return [`/api/v1/locations/directory/${directoryId}`] as const;
    }

    
export const getGetLocationsByDirectoryQueryOptions = <TData = Awaited<ReturnType<typeof getLocationsByDirectory>>, TError = unknown>(directoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationsByDirectory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLocationsByDirectoryQueryKey(directoryId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocationsByDirectory>>> = ({ signal }) => getLocationsByDirectory(directoryId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(directoryId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLocationsByDirectory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLocationsByDirectoryQueryResult = NonNullable<Awaited<ReturnType<typeof getLocationsByDirectory>>>
export type GetLocationsByDirectoryQueryError = unknown


export function useGetLocationsByDirectory<TData = Awaited<ReturnType<typeof getLocationsByDirectory>>, TError = unknown>(
 directoryId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationsByDirectory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocationsByDirectory>>,
          TError,
          Awaited<ReturnType<typeof getLocationsByDirectory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLocationsByDirectory<TData = Awaited<ReturnType<typeof getLocationsByDirectory>>, TError = unknown>(
 directoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationsByDirectory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocationsByDirectory>>,
          TError,
          Awaited<ReturnType<typeof getLocationsByDirectory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLocationsByDirectory<TData = Awaited<ReturnType<typeof getLocationsByDirectory>>, TError = unknown>(
 directoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationsByDirectory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get locations by directory ID
 */

export function useGetLocationsByDirectory<TData = Awaited<ReturnType<typeof getLocationsByDirectory>>, TError = unknown>(
 directoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationsByDirectory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLocationsByDirectoryQueryOptions(directoryId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get root level locations (zones)
 */
export const getRootLocations = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LocationDTO[]>(
      {url: `/api/v1/locations/children`, method: 'GET', signal
    },
      options);
    }
  

export const getGetRootLocationsQueryKey = () => {
    return [`/api/v1/locations/children`] as const;
    }

    
export const getGetRootLocationsQueryOptions = <TData = Awaited<ReturnType<typeof getRootLocations>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRootLocations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRootLocationsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRootLocations>>> = ({ signal }) => getRootLocations(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRootLocations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetRootLocationsQueryResult = NonNullable<Awaited<ReturnType<typeof getRootLocations>>>
export type GetRootLocationsQueryError = unknown


export function useGetRootLocations<TData = Awaited<ReturnType<typeof getRootLocations>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRootLocations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRootLocations>>,
          TError,
          Awaited<ReturnType<typeof getRootLocations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRootLocations<TData = Awaited<ReturnType<typeof getRootLocations>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRootLocations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRootLocations>>,
          TError,
          Awaited<ReturnType<typeof getRootLocations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRootLocations<TData = Awaited<ReturnType<typeof getRootLocations>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRootLocations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get root level locations (zones)
 */

export function useGetRootLocations<TData = Awaited<ReturnType<typeof getRootLocations>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRootLocations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetRootLocationsQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get child locations by parent ID
 */
export const getLocationsByParentId = (
    parentId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LocationDTO[]>(
      {url: `/api/v1/locations/children/${parentId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetLocationsByParentIdQueryKey = (parentId?: number,) => {
    return [`/api/v1/locations/children/${parentId}`] as const;
    }

    
export const getGetLocationsByParentIdQueryOptions = <TData = Awaited<ReturnType<typeof getLocationsByParentId>>, TError = unknown>(parentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationsByParentId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLocationsByParentIdQueryKey(parentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocationsByParentId>>> = ({ signal }) => getLocationsByParentId(parentId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(parentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLocationsByParentId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLocationsByParentIdQueryResult = NonNullable<Awaited<ReturnType<typeof getLocationsByParentId>>>
export type GetLocationsByParentIdQueryError = unknown


export function useGetLocationsByParentId<TData = Awaited<ReturnType<typeof getLocationsByParentId>>, TError = unknown>(
 parentId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationsByParentId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocationsByParentId>>,
          TError,
          Awaited<ReturnType<typeof getLocationsByParentId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLocationsByParentId<TData = Awaited<ReturnType<typeof getLocationsByParentId>>, TError = unknown>(
 parentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationsByParentId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocationsByParentId>>,
          TError,
          Awaited<ReturnType<typeof getLocationsByParentId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLocationsByParentId<TData = Awaited<ReturnType<typeof getLocationsByParentId>>, TError = unknown>(
 parentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationsByParentId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get child locations by parent ID
 */

export function useGetLocationsByParentId<TData = Awaited<ReturnType<typeof getLocationsByParentId>>, TError = unknown>(
 parentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationsByParentId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLocationsByParentIdQueryOptions(parentId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



